import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';

// TanStack Router needs that file for file based routing
export const Route = createFileRoute('/_auth')({
  beforeLoad({ context }) {
    const auth = context.msalInstance;
    const accounts = auth?.getAllAccounts() ?? [];

    if (accounts.length === 0) {
      throw redirect({
        to: '/',
        search: {
          redirect: location.href,
        },
      });
    }
  },
  component: AuthLayout,
});

function AuthLayout() {
  return <Outlet />;
}
